// extracted by mini-css-extract-plugin
module.exports = {"appShell":"app-shell_appShell__NzOaX","logo":"app-shell_logo__2OvjX","header":"app-shell_header__1lzk1","content":"app-shell_content__S8Dqs","main":"app-shell_main__Zn22R"};